/* eslint-disable */
export function generateIframeContent(richTextContent) {
  // eslint-disable-next-line no-unused-vars, no-useless-escape
  const htmlParts = ['<!DOCTYPE html>',
  '<html>',
  '<head>',
  '<meta charset="UTF-8">',
  '<style>.mce-content-body div.mce-resizehandle {position: absolute;border: 1px solid black;box-sizing: content-box;background: #FFF;width: 7px;height: 7px;z-index: 10000}.mce-content-body .mce-resizehandle:hover {background: #000}.mce-content-body img[data-mce-selected],.mce-content-body hr[data-mce-selected] {outline: 1px solid black;resize: none}.mce-content-body .mce-clonedresizable {position: absolute;outline: 1px dashed black;opacity: .5;filter: alpha(opacity=50);z-index: 10000}.mce-content-body .mce-resize-helper {background: #555;background: rgba(0,0,0,0.75);border-radius: 3px;border: 1px;color: white;display: none;font-family: sans-serif;font-size: 12px;white-space: nowrap;line-height: 14px;margin: 5px 10px;padding: 5px;position: absolute;z-index: 10001}.mce-visual-caret {position: absolute;background-color: black;background-color: currentcolor;}.mce-visual-caret-hidden {display: none;}*[data-mce-caret] {position: absolute;left: -1000px;right: auto;top: 0;margin: 0;padding: 0;}.mce-content-body .mce-offscreen-selection {position: absolute;left: -9999999999px;max-width: 1000000px;}.mce-content-body *[contentEditable=false] {cursor: default;}.mce-content-body *[contentEditable=true] {cursor: text;}</style>',
  '<link rel="stylesheet" type="text/css" id="u0" href="https://school.vip.com/tinymce-all-in-one/skins/lightgray/content.min.css">',
  '<style>img {max-width: 100%;max-height: 100%;}</style>',
  '<link rel="stylesheet" data-mce-href="https://school.vip.com/tinymce-all-in-one/plugins/codesample/css/prism.css" href="https://school.vip.com/tinymce-all-in-one/plugins/codesample/css/prism.css">',
  '</head>',
  '<body>',
  richTextContent,
  '<script>',
  'function sendHeight () {',
  '  const height = Math.max(',
  '    document.body.scrollHeight,',
  '    document.body.offsetHeight',
  ');',
  'window.parent.postMessage({ type: \'iframeHeight\', id: \'richTextFrame\', height: height }, \'*\');',
  // ' console.log(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight, height);',
  '}',
  'if (document.readyState === "loading") {',
  '    document.addEventListener(\'DOMContentLoaded\', sendHeight);',
  '} else {',
  '    sendHeight();',
  '}',
  'window.addEventListener(\'resize\', function () {',
  '   window.clearTimeout(window.resizeTimer);',
  '   window.resizeTimer = setTimeout(sendHeight, 100);',
  '});',
  '<\/script>',
  '</body>',
  '</html>']
  return htmlParts.join('')
}